import Resources from "shared/actions/resourcesActions";

export default class MessagesResource extends Resources {
  constructor(dispatch, activityId) {
    super(dispatch, "message", `/api/v1/activities/${activityId}/messages`);
  }
}
